import Styled, { css } from 'styled-components';
import Button from './Button';
import React from 'react';
import { CircularProgress } from '@material-ui/core';

export function PrimaryButton(props) {
  return (
    <PB {...props}>
      {props.loading ? (
        <CircularProgress size={20} color="white" />
      ) : (
        props.children
      )}
    </PB>
  );
}

const PB = Styled(Button).attrs({
  variant: 'contained'
})`
  && {
    background: linear-gradient(
      to bottom left,
      ${props => props.theme.palette.primary['500']},
      ${props => props.theme.palette.primary['700']}
    );
    font-weight: 600;
    &:after {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgb(0, 0, 0);
      opacity: 0;
      transition: all 0.3s;
    }
    &:hover:after {
      opacity: 0.1;
    }
    ${props =>
      props.disabled &&
      css`
        && {
          background: #9a9a9a;
          color: white;
          cursor: not-allowed;
        }
      `}
      @media (max-width: 600px)  {
        margin-right: ${props => props.marginright || '15em'};
      }
  }
`;
